import { useTranslation } from '@/i18n/hook';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative min-h-[600px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Vibrant%20streetwear%20fashion%20collection%20flat%20lay%20with%20sneakers%20hoodies%20baseball%20caps%20and%20handbags%20arranged%20on%20soft%20pastel%20peach%20background%20bold%20editorial%20product%20photography%20bright%20clean%20modern%20aesthetic&width=1600&height=900&seq=hero-2026-bg&orientation=landscape&nocache=true"
          alt="CSSBuy Spreadsheet products"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-50/95 via-background-50/80 to-background-50/40" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6 py-20 w-full">
        <div className="max-w-2xl">
          <p className="text-sm font-medium text-primary-600 tracking-wider uppercase mb-4">
            {t('hero.eyebrow')}
          </p>
          <h1 className="font-heading text-3xl md:text-5xl font-bold text-foreground-900 leading-tight mb-6">
            {t('hero.h1')}
          </h1>
          <p className="text-base md:text-lg text-foreground-700 leading-relaxed mb-8">
            {t('hero.subtitle')}
          </p>
          <div className="flex flex-col sm:flex-row gap-3 mb-8">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center px-6 py-3 bg-primary-500 text-background-50 font-medium rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              {t('hero.cta.primary')}
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center px-6 py-3 bg-background-100 text-foreground-800 font-medium rounded-lg border border-background-200/70 hover:bg-background-200/70 transition-colors whitespace-nowrap"
            >
              {t('hero.cta.secondary')}
            </a>
          </div>
          <p className="text-xs text-foreground-500 tracking-wide">
            {t('hero.trust')}
          </p>
        </div>
      </div>
    </section>
  );
}